import {
  Card,
  CardContent,
  Grid2,
  Stack,
  Typography,
  useTheme,
} from '@mui/material'
import { useState } from 'react'
import SingleColumnLayout from '../../layouts/single-column-layout/single-column-layout'
import Quickbooks from '../../assets/images/quickbooks.png'
import Motive from '../../assets/images/motive.png'
import BorderConnect from '../../assets/images/borderconnect.png'
import { IntegrationChip } from './integration.styles'
import EnableBorderConnectDialog from './enable-borderconnect-dialog'
import BorderConnectManifestsDialog from './borderconnect-manifests-dialog'
import { useGetIntegrationStatusesQuery } from 'store/integrations/integrations.api'
import { getUserId } from 'utils/common'

const disabledCardSx = {
  borderRadius: 0,
  opacity: 0.5,
  pointerEvents: 'none',
  filter: 'grayscale(0.25)',
}

const Integration = () => {
  const theme = useTheme()
  const userId = getUserId()
  const [isBorderConnectDialogOpen, setIsBorderConnectDialogOpen] =
    useState(false)
  const [isBorderConnectViewOpen, setIsBorderConnectViewOpen] = useState(false)

  const { data: statuses } = useGetIntegrationStatusesQuery(
    { userId },
    { skip: !userId }
  )

  const borderConnectStatus = statuses?.find(
    (status) => status.integrationType === 'BORDERCONNECT' && status.enabled
  )
  const isBorderConnectEnabled = Boolean(borderConnectStatus)

  return (
    <SingleColumnLayout>
      <Grid2 container p={2} sx={{ height: 'calc(100vh - 80px)' }} spacing={2}>
        <Grid2 size={{ xs: 12, md: 3 }}>
          <Card sx={{ borderRadius: 0 }} elevation={4}>
            <CardContent
              sx={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: 250,
                justifyContent: 'space-between',
              }}
            >
              <img
                src={BorderConnect}
                width={160}
                height={40}
                alt="borderconnect"
                style={{ objectFit: 'contain', objectPosition: 'left' }}
              />
              <Typography fontWeight={300}>
                File ACE and ACI e-manifests and manage US–Canada border
                crossings from Transpots using BorderConnect.
              </Typography>

              <Stack direction="row" justifyContent="space-between">
                <IntegrationChip style={{ border: '1px solid #D9D9D9' }}>
                  Compliance
                </IntegrationChip>

                {isBorderConnectEnabled ? (
                  <Stack direction="row" spacing={1}>
                    <IntegrationChip
                      role="button"
                      onClick={() => setIsBorderConnectViewOpen(true)}
                      style={{
                        border: '1px solid #D9D9D9',
                        cursor: 'pointer',
                      }}
                    >
                      View
                    </IntegrationChip>
                    <IntegrationChip
                      style={{
                        backgroundColor: theme.palette.success.main,
                        color: theme.palette.common.white,
                      }}
                    >
                      Enabled
                    </IntegrationChip>
                  </Stack>
                ) : (
                  <IntegrationChip
                    role="button"
                    onClick={() => setIsBorderConnectDialogOpen(true)}
                    style={{
                      backgroundColor: theme.palette.primary.main,
                      color: theme.palette.common.white,
                      cursor: 'pointer',
                    }}
                  >
                    Enable App
                  </IntegrationChip>
                )}
              </Stack>
            </CardContent>
          </Card>
        </Grid2>

        <Grid2 size={{ xs: 12, md: 3 }}>
          <Card sx={disabledCardSx} elevation={4} aria-disabled>
            <CardContent
              sx={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: 250,
                justifyContent: 'space-between',
              }}
            >
              <img src={Quickbooks} width={120} height={30} alt="quickbooks" />
              <Typography fontWeight={300}>
                1. Invoices created in Transpots automatically export to
                QuickBooks.
              </Typography>
              <Typography fontWeight={300}>
                2. Any changes made are updated in both systems
              </Typography>

              <Stack direction="row" justifyContent="space-between">
                <IntegrationChip style={{ border: '1px solid #D9D9D9' }}>
                  Financial
                </IntegrationChip>

                <IntegrationChip
                  style={{
                    backgroundColor: theme.palette.action.disabledBackground,
                    color: theme.palette.text.disabled,
                  }}
                >
                  Coming Soon
                </IntegrationChip>
              </Stack>
            </CardContent>
          </Card>
        </Grid2>

        <Grid2 size={{ xs: 12, md: 3 }}>
          <Card sx={disabledCardSx} elevation={4} aria-disabled>
            <CardContent
              sx={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: 250,
                justifyContent: 'space-between',
              }}
            >
              <img src={Motive} width={110} height={50} alt="motive" />
              <Typography fontWeight={300}>
                Enable real-time track and trace for your trucks & track driver
                HOS using Motive&#39;s GPS data
              </Typography>

              <Stack direction="row" justifyContent="space-between">
                <IntegrationChip style={{ border: '1px solid #D9D9D9' }}>
                  Track & Trace
                </IntegrationChip>

                <IntegrationChip
                  style={{
                    backgroundColor: theme.palette.action.disabledBackground,
                    color: theme.palette.text.disabled,
                  }}
                >
                  Coming Soon
                </IntegrationChip>
              </Stack>
            </CardContent>
          </Card>
        </Grid2>
      </Grid2>
      <EnableBorderConnectDialog
        open={isBorderConnectDialogOpen}
        handleClose={() => setIsBorderConnectDialogOpen(false)}
      />
      <BorderConnectManifestsDialog
        open={isBorderConnectViewOpen}
        handleClose={() => setIsBorderConnectViewOpen(false)}
      />
    </SingleColumnLayout>
  )
}

export default Integration
